import { Icon } from '@iconify/react/dist/iconify.js'
import React from 'react'
import { Link } from 'react-router-dom'

const ContainerDetails = ({ umbrellaManage }) => {

    console.log("Umbrella", umbrellaManage)


    const containerDummy = [
        {
            name: "Electronics Batch A",
            status: "SHIPPED",
            expected_date: "2025-07-23",
            shipment_type: "AIR",
        },
        {
            name: "Furniture Load B",
            status: "REACHED_TO_LOCAL_PARTNER",
            expected_date: "2025-07-28",
            shipment_type: "SHIP",
        },
        {
            name: "Medical Supplies",
            status: "DELIVERED",
            expected_date: "2025-05-29",
            shipment_type: "AIR",
        },
        {
            name: "Apparel Shipment C",
            status: "PROCESSING",
            expected_date: "2025-08-10",
            shipment_type: "SHIP",
        },
        {
            name: "Automotive Parts",
            status: "SHIPPED",
            expected_date: "2025-06-15",
            shipment_type: "AIR",
        },
        {
            name: "Automotive Parts",
            status: "SHIPPED",
            expected_date: "2025-06-15",
            shipment_type: "AIR",
        },
    ];


    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    return (
        <div className="col-xxl-6 col-lg-12">
            <div className="card h-100">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20">
                        <h6 className="mb-2 fw-bold text-lg mb-0">Container Details</h6>
                        <Link
                            to={"/umbrella-managemnt"}
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                        >
                            Manage
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon"
                            />
                        </Link>
                    </div>

                    {umbrellaManage?.length > 0 ? (
                    <div className="mt-32">

                        {

             
                        
                        
                        
                        
                        umbrellaManage?.map((container, idx) => (
                            <div
                                className={`d-flex align-items-center justify-content-between gap-3 ${idx !== containerDummy.length - 1 ? 'mb-32' : ''
                                    }`}
                                key={idx}
                            >
                                <div className="d-flex align-items-center gap-10">
                                    <div className="w-40-px h-40-px radius-8 d-flex justify-content-center align-items-center text-primary-600 bg-primary-light border border-primary-light-white flex-shrink-0">
                                        <Icon
                                            icon={container?.shipment_type === 'AIR' ? 'mdi:airplane' : 'mdi:cargo-ship'}
                                            className=""
                                            width="24"
                                            height="24"
                                        />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h6 className="text-md mb-0 fw-semibold">{container?.identifier_id}</h6>
                                        <span className="text-sm fw-medium text-secondary">
                                            {container?.order_status}
                                        </span>
                                    </div>
                                </div>
                                <span className="text-primary-light text-md fw-bold text-start">
                                    {container?.order_status !== "REACHED_TO_LOCAL_PARTNER"
                                        ? `Arrives: ${formatDate(container?.expected_date)}`
                                        : "-"}
                                </span>

                            </div>))

                          
                            
                        
                        
                        }

                    </div>

                    ) : <div className='h-100' style={{display:"flex", justifyContent:"center", alignItems:"center"}}>

                        No Containers Data Found
                        </div>
                    
                    
                    }
                </div>
            </div>
        </div>
    )
}

export default ContainerDetails